export default __webpack_public_path__ + "static/media/placeholder_dummy2016-ernaehrungsberatung.5b957087.png";